import type { ReportHandler } from 'web-vitals';
import { logPlatformEvent } from './utils/platformAnalytics';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  const handler: ReportHandler = (metric) => {
    logPlatformEvent('web_vitals', {
      metric_name: metric.name,
      metric_value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      metric_id: metric.id.slice(0, 32),
    });
    onPerfEntry?.(metric);
  };

  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(handler);
    getFID(handler);
    getFCP(handler);
    getLCP(handler);
    getTTFB(handler);
  });
};

export default reportWebVitals;
